import Fresco41 from "./fresco4.webp";

const Fresco4 = [Fresco41];

export default Fresco4;
